export const DashordSVG = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 15 16"
      fill="none"
      className={className}
    >
      <path
        d="M7.66289 3.46748C7.61927 3.42575 7.56124 3.40247 7.50088 3.40247C7.44052 3.40247 7.38248 3.42575 7.33887 3.46748L1.94531 8.61992C1.92241 8.64183 1.90418 8.66816 1.89175 8.69731C1.87931 8.72647 1.87291 8.75785 1.87295 8.78955L1.87207 13.6253C1.87207 13.8739 1.97084 14.1124 2.14666 14.2882C2.32247 14.464 2.56093 14.5628 2.80957 14.5628H5.625C5.74932 14.5628 5.86855 14.5134 5.95645 14.4255C6.04436 14.3376 6.09375 14.2184 6.09375 14.094V10.1097C6.09375 10.0475 6.11844 9.98789 6.1624 9.94393C6.20635 9.89998 6.26596 9.87529 6.32812 9.87529H8.67187C8.73403 9.87529 8.79365 9.89998 8.8376 9.94393C8.88155 9.98789 8.90625 10.0475 8.90625 10.1097V14.094C8.90625 14.2184 8.95563 14.3376 9.04354 14.4255C9.13145 14.5134 9.25068 14.5628 9.375 14.5628H12.1893C12.4379 14.5628 12.6764 14.464 12.8522 14.2882C13.028 14.1124 13.1268 13.8739 13.1268 13.6253V8.78955C13.1268 8.75785 13.1204 8.72647 13.108 8.69731C13.0955 8.66816 13.0773 8.64183 13.0544 8.61992L7.66289 3.46748Z"
        // fill="#A0AEC0"
      />
      <path
        d="M14.3825 7.65369L12.1911 5.5572V2.37585C12.1911 2.25153 12.1417 2.13231 12.0538 2.0444C11.9659 1.95649 11.8467 1.9071 11.7223 1.9071H10.3161C10.1918 1.9071 10.0725 1.95649 9.98464 2.0444C9.89673 2.13231 9.84735 2.25153 9.84735 2.37585V3.31335L8.15047 1.69089C7.99168 1.53035 7.75555 1.43835 7.50037 1.43835C7.24608 1.43835 7.01053 1.53035 6.85174 1.69119L0.620299 7.6531C0.438073 7.82888 0.415221 8.11804 0.581041 8.30847C0.622681 8.35654 0.673667 8.39563 0.730894 8.42337C0.788122 8.4511 0.850395 8.46691 0.913924 8.46981C0.977453 8.47272 1.04091 8.46266 1.10043 8.44026C1.15995 8.41787 1.21429 8.38359 1.26014 8.33953L7.33924 2.53054C7.38286 2.48882 7.44089 2.46553 7.50125 2.46553C7.56161 2.46553 7.61965 2.48882 7.66327 2.53054L13.7429 8.33953C13.8325 8.42541 13.9525 8.47228 14.0765 8.46986C14.2006 8.46745 14.3186 8.41594 14.4048 8.32663C14.5846 8.14031 14.5697 7.83269 14.3825 7.65369Z"
        // fill="#A0AEC0"
      />
    </svg>
  );
};
export const PatientSVG = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 15 15"
      fill="none"
      className={className}
    >
      <path
        d="M7.5 2.5C8.16304 2.5 8.79892 2.76339 9.26777 3.23223C9.73661 3.70107 10 4.33696 10 5C10 5.66304 9.73661 6.29893 9.26777 6.76777C8.79892 7.23661 8.16304 7.5 7.5 7.5C6.83696 7.5 6.20107 7.23661 5.73223 6.76777C5.26339 6.29893 5 5.66304 5 5C5 4.33696 5.26339 3.70107 5.73223 3.23223C6.20107 2.76339 6.83696 2.5 7.5 2.5ZM7.5 8.75C10.2625 8.75 12.5 9.86875 12.5 11.25V12.5H2.5V11.25C2.5 9.86875 4.7375 8.75 7.5 8.75Z"
        // fill="#A0AEC0"
      />
    </svg>
  );
};
export const CameraSVG = ({ className }: any) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="camera">
      <path d="M19,6.5H17.72l-.32-1a3,3,0,0,0-2.84-2H9.44A3,3,0,0,0,6.6,5.55l-.32,1H5a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3v-8A3,3,0,0,0,19,6.5Zm1,11a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1v-8a1,1,0,0,1,1-1H7a1,1,0,0,0,1-.68l.54-1.64a1,1,0,0,1,.95-.68h5.12a1,1,0,0,1,.95.68l.54,1.64A1,1,0,0,0,17,8.5h2a1,1,0,0,1,1,1Zm-8-9a4,4,0,1,0,4,4A4,4,0,0,0,12,8.5Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14.5Z"></path>
    </svg>
  );
};
export const AppointmentSVG = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M12 14.6663C12.3536 14.6663 12.6928 14.5259 12.9428 14.2758C13.1929 14.0258 13.3333 13.6866 13.3333 13.333V5.33301L9.33334 1.33301H4.00001C3.64638 1.33301 3.30724 1.47348 3.0572 1.72353C2.80715 1.97358 2.66667 2.31272 2.66667 2.66634V13.333C2.66667 13.6866 2.80715 14.0258 3.0572 14.2758C3.30724 14.5259 3.64638 14.6663 4.00001 14.6663H12ZM8.66667 2.66634L12 5.99967H8.66667V2.66634ZM4.66667 5.33301H6.66667V6.66634H4.66667V5.33301ZM4.66667 7.99967H11.3333V9.33301H4.66667V7.99967ZM4.66667 10.6663H11.3333V11.9997H4.66667V10.6663Z"
        // fill="#A0AEC0"
      />
    </svg>
  );
};
export const TreatmentSVG = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 10 10"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.705 0.827C2.0715 0.6095 2.5055 0.5 3 0.5C3.488 0.5 3.904 0.7465 4.191 0.9165C4.434 1.0615 4.706 1.25 5 1.25C5.294 1.25 5.566 1.061 5.809 0.9165C6.0965 0.747 6.512 0.5 7 0.5C7.495 0.5 7.929 0.6095 8.295 0.827C8.661 1.0445 8.9315 1.354 9.123 1.711C9.498 2.409 9.583 3.307 9.5315 4.181C9.479 5.0685 9.2815 5.9965 9.031 6.8035C8.782 7.604 8.469 8.3225 8.166 8.7775C7.818 9.299 7.3345 9.5585 6.822 9.4865C6.3515 9.4205 5.986 9.09 5.803 8.7235C5.6075 8.3325 5.517 7.896 5.3455 7.4945C5.2605 7.2965 5.179 7.1565 5.103 7.072C5.023 6.984 4.9745 6.9865 4.8975 7.072C4.821 7.1565 4.7395 7.2965 4.6545 7.4945C4.483 7.896 4.393 8.3325 4.1975 8.7235C4.014 9.09 3.6485 9.4205 3.1785 9.4865C2.6655 9.5585 2.182 9.299 1.834 8.7775C1.531 8.3225 1.218 7.604 0.969004 6.8035C0.718504 5.9965 0.521004 5.0685 0.469004 4.1815C0.417004 3.3065 0.502004 2.409 0.877004 1.711C1.0685 1.354 1.339 1.0445 1.705 0.827Z"
        // fill="#A0AEC0"
      />
    </svg>
  );
};
export const PaymentSVG = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M3.5 3C2.83696 3 2.20107 3.26339 1.73223 3.73223C1.26339 4.20107 1 4.83696 1 5.5V6H15V5.5C15 4.83696 14.7366 4.20107 14.2678 3.73223C13.7989 3.26339 13.163 3 12.5 3H3.5ZM15 7H1V10.5C1 11.163 1.26339 11.7989 1.73223 12.2678C2.20107 12.7366 2.83696 13 3.5 13H12.5C13.163 13 13.7989 12.7366 14.2678 12.2678C14.7366 11.7989 15 11.163 15 10.5V7ZM10.5 10H12.5C12.6326 10 12.7598 10.0527 12.8536 10.1464C12.9473 10.2402 13 10.3674 13 10.5C13 10.6326 12.9473 10.7598 12.8536 10.8536C12.7598 10.9473 12.6326 11 12.5 11H10.5C10.3674 11 10.2402 10.9473 10.1464 10.8536C10.0527 10.7598 10 10.6326 10 10.5C10 10.3674 10.0527 10.2402 10.1464 10.1464C10.2402 10.0527 10.3674 10 10.5 10Z"
        // fill="#A0AEC0"
      />
    </svg>
  );
};
export const StaffSVG = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M5.59985 6.39998C6.23637 6.39998 6.84682 6.14712 7.29691 5.69703C7.74699 5.24694 7.99985 4.63649 7.99985 3.99998C7.99985 3.36346 7.74699 2.75301 7.29691 2.30292C6.84682 1.85283 6.23637 1.59998 5.59985 1.59998C4.96333 1.59998 4.35288 1.85283 3.90279 2.30292C3.45271 2.75301 3.19985 3.36346 3.19985 3.99998C3.19985 4.63649 3.45271 5.24694 3.90279 5.69703C4.35288 6.14712 4.96333 6.39998 5.59985 6.39998ZM11.5999 7.19998C12.1303 7.19998 12.639 6.98926 13.0141 6.61419C13.3891 6.23912 13.5999 5.73041 13.5999 5.19998C13.5999 4.66954 13.3891 4.16083 13.0141 3.78576C12.639 3.41069 12.1303 3.19998 11.5999 3.19998C11.0694 3.19998 10.5607 3.41069 10.1856 3.78576C9.81056 4.16083 9.59985 4.66954 9.59985 5.19998C9.59985 5.73041 9.81056 6.23912 10.1856 6.61419C10.5607 6.98926 11.0694 7.19998 11.5999 7.19998ZM1.29185 13.1424C1.135 13.0446 1.00902 12.9045 0.928464 12.7381C0.847912 12.5718 0.816081 12.386 0.83665 12.2024C0.984135 11.0432 1.54925 9.97762 2.4261 9.20527C3.30295 8.43292 4.43135 8.00682 5.59985 8.00682C6.76835 8.00682 7.89675 8.43292 8.7736 9.20527C9.65045 9.97762 10.2156 11.0432 10.3631 12.2024C10.4095 12.576 10.2255 12.9384 9.90705 13.1416C8.62165 13.9653 7.12653 14.4021 5.59985 14.4C4.07297 14.4025 2.57757 13.966 1.29185 13.1424ZM11.5999 12.8H11.5151C11.5711 12.5624 11.5855 12.3112 11.5535 12.0536C11.4167 10.9538 10.9769 9.91374 10.2831 9.04958C10.7295 8.87388 11.2067 8.78918 11.6863 8.80044C12.166 8.8117 12.6386 8.91869 13.0764 9.11514C13.5142 9.31159 13.9083 9.59353 14.2355 9.94441C14.5628 10.2953 14.8167 10.708 14.9823 11.1584C15.0331 11.3021 15.0322 11.4592 14.9796 11.6023C14.927 11.7454 14.8261 11.8657 14.6943 11.9424C13.7604 12.5054 12.6903 12.802 11.5999 12.8Z"
        // fill="#A0AEC0"
      />
    </svg>
  );
};
export const SettingSVG = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M8.00782 6.10332C7.54063 6.10332 7.10313 6.28457 6.77188 6.61582C6.44219 6.94707 6.25938 7.38457 6.25938 7.85176C6.25938 8.31895 6.44219 8.75644 6.77188 9.0877C7.10313 9.41738 7.54063 9.6002 8.00782 9.6002C8.47501 9.6002 8.91251 9.41738 9.24376 9.0877C9.57344 8.75644 9.75626 8.31895 9.75626 7.85176C9.75626 7.38457 9.57344 6.94707 9.24376 6.61582C9.08197 6.45278 8.88939 6.32352 8.67722 6.23554C8.46505 6.14756 8.23751 6.10262 8.00782 6.10332ZM14.45 9.78301L13.4281 8.90957C13.4766 8.6127 13.5016 8.30957 13.5016 8.00801C13.5016 7.70645 13.4766 7.40176 13.4281 7.10645L14.45 6.23301C14.5272 6.16692 14.5825 6.07891 14.6084 5.98066C14.6344 5.88242 14.6298 5.7786 14.5953 5.68301L14.5813 5.64238C14.3 4.85596 13.8786 4.127 13.3375 3.49082L13.3094 3.45801C13.2437 3.38075 13.1561 3.32521 13.0582 3.29871C12.9603 3.27221 12.8567 3.276 12.7609 3.30957L11.4922 3.76113C11.0234 3.37676 10.5016 3.07363 9.93595 2.8627L9.69063 1.53613C9.67212 1.4362 9.62365 1.34426 9.55164 1.27254C9.47964 1.20081 9.38751 1.15269 9.28751 1.13457L9.24532 1.12676C8.43282 0.979883 7.57657 0.979883 6.76407 1.12676L6.72188 1.13457C6.62188 1.15269 6.52975 1.20081 6.45775 1.27254C6.38574 1.34426 6.33727 1.4362 6.31876 1.53613L6.07188 2.86895C5.51161 3.08156 4.98969 3.38395 4.52657 3.76426L3.24844 3.30957C3.15277 3.27573 3.04906 3.27181 2.95109 3.29832C2.85313 3.32483 2.76556 3.38053 2.70001 3.45801L2.67188 3.49082C2.13171 4.12768 1.71043 4.85646 1.42813 5.64238L1.41407 5.68301C1.34376 5.87832 1.40157 6.09707 1.55938 6.23301L2.59376 7.11582C2.54532 7.40957 2.52188 7.70957 2.52188 8.00645C2.52188 8.30645 2.54532 8.60645 2.59376 8.89707L1.56251 9.77988C1.48531 9.84597 1.43006 9.93398 1.40411 10.0322C1.37815 10.1305 1.38272 10.2343 1.4172 10.3299L1.43126 10.3705C1.71407 11.1564 2.13126 11.883 2.67501 12.5221L2.70313 12.5549C2.76884 12.6321 2.85642 12.6877 2.95432 12.7142C3.05223 12.7407 3.15586 12.7369 3.25157 12.7033L4.5297 12.2486C4.99532 12.6314 5.51407 12.9346 6.07501 13.1439L6.32188 14.4768C6.34039 14.5767 6.38887 14.6686 6.46087 14.7404C6.53288 14.8121 6.625 14.8602 6.72501 14.8783L6.7672 14.8861C7.58769 15.0338 8.42795 15.0338 9.24845 14.8861L9.29063 14.8783C9.39064 14.8602 9.48276 14.8121 9.55477 14.7404C9.62677 14.6686 9.67525 14.5767 9.69376 14.4768L9.93907 13.1502C10.5047 12.9377 11.0266 12.6361 11.4953 12.2518L12.7641 12.7033C12.8597 12.7372 12.9635 12.7411 13.0614 12.7146C13.1594 12.6881 13.247 12.6324 13.3125 12.5549L13.3406 12.5221C13.8844 11.8799 14.3016 11.1564 14.5844 10.3705L14.5984 10.3299C14.6656 10.1361 14.6078 9.91895 14.45 9.78301ZM8.00782 10.5986C6.49063 10.5986 5.26095 9.36895 5.26095 7.85176C5.26095 6.33457 6.49063 5.10488 8.00782 5.10488C9.52501 5.10488 10.7547 6.33457 10.7547 7.85176C10.7547 9.36895 9.52501 10.5986 8.00782 10.5986Z"
        // fill="white"
      />
    </svg>
  );
};

export const SelectArrowDown = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={className}
      fill="none"
    >
      <mask
        id="mask0_53_332"
        maskUnits="userSpaceOnUse"
        x="3"
        y="6"
        width="10"
        height="6"
      >
        <path
          d="M12 6.66663L8 10.6666L4 6.66663L12 6.66663Z"
          fill="white"
          stroke="white"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_53_332)">
        <path
          d="M16 0L16 16L-6.99382e-07 16L0 -6.99382e-07L16 0Z"
          fill="#3182CE"
        />
      </g>
    </svg>
  );
};
export const ArrowRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask
        id="mask0_45_173"
        maskUnits="userSpaceOnUse"
        x="6"
        y="3"
        width="6"
        height="10"
      >
        <path
          d="M6.66666 4L10.6667 8L6.66666 12V4Z"
          fill="white"
          stroke="white"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_45_173)">
        <path d="M0 0H16V16H0V0Z" fill="#A0AEC0" />
      </g>
    </svg>
  );
};

export const BellSvg = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M6.25 23.75C5.89584 23.75 5.59875 23.63 5.35875 23.39C5.11875 23.15 4.99917 22.8533 5 22.5C5 22.1458 5.12 21.8488 5.36 21.6088C5.6 21.3688 5.89667 21.2492 6.25 21.25H7.5V12.5C7.5 10.7708 8.02084 9.23417 9.0625 7.89C10.1042 6.54584 11.4583 5.66584 13.125 5.25V4.375C13.125 3.85417 13.3075 3.41125 13.6725 3.04625C14.0375 2.68125 14.48 2.49917 15 2.5C15.5208 2.5 15.9638 2.6825 16.3288 3.0475C16.6938 3.4125 16.8758 3.855 16.875 4.375V5.25C18.5417 5.66667 19.8958 6.54709 20.9375 7.89125C21.9792 9.23542 22.5 10.7717 22.5 12.5V21.25H23.75C24.1042 21.25 24.4013 21.37 24.6413 21.61C24.8813 21.85 25.0008 22.1467 25 22.5C25 22.8542 24.88 23.1513 24.64 23.3913C24.4 23.6313 24.1033 23.7508 23.75 23.75H6.25ZM15 27.5C14.3125 27.5 13.7238 27.255 13.2338 26.765C12.7438 26.275 12.4992 25.6867 12.5 25H17.5C17.5 25.6875 17.255 26.2763 16.765 26.7663C16.275 27.2563 15.6867 27.5008 15 27.5Z"
          fill="rgb(140, 140, 140)"
        />
      </svg>
    </div>
  );
};
export const UserSvg = ({ onClick }: any) => {
  return (
    <svg
      onClick={() => onClick()}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 5C13.251 4.99968 11.5324 5.45811 10.0159 6.32954C8.4994 7.20096 7.23797 8.4549 6.35753 9.96619C5.4771 11.4775 5.00844 13.1933 4.99835 14.9423C4.98825 16.6913 5.43708 18.4124 6.30001 19.9338C6.88328 19.1757 7.63305 18.562 8.49137 18.14C9.34969 17.718 10.2936 17.499 11.25 17.5H18.75C19.7065 17.499 20.6503 17.718 21.5087 18.14C22.367 18.562 23.1167 19.1757 23.7 19.9338C24.563 18.4124 25.0118 16.6913 25.0017 14.9423C24.9916 13.1933 24.5229 11.4775 23.6425 9.96619C22.7621 8.4549 21.5006 7.20096 19.9841 6.32954C18.4676 5.45811 16.7491 4.99968 15 5ZM24.9288 22.595C26.6 20.4162 27.504 17.746 27.5 15C27.5 8.09625 21.9038 2.5 15 2.5C8.09626 2.5 2.50001 8.09625 2.50001 15C2.49589 17.746 3.3999 20.4163 5.07126 22.595L5.06501 22.6175L5.50876 23.1338C6.68112 24.5044 8.13674 25.6045 9.7753 26.3583C11.4139 27.1121 13.1964 27.5016 15 27.5C17.5342 27.5047 20.0093 26.7349 22.0938 25.2938C22.9824 24.6798 23.7882 23.9538 24.4913 23.1338L24.935 22.6175L24.9288 22.595ZM15 7.5C14.0055 7.5 13.0516 7.89509 12.3484 8.59835C11.6451 9.30161 11.25 10.2554 11.25 11.25C11.25 12.2446 11.6451 13.1984 12.3484 13.9017C13.0516 14.6049 14.0055 15 15 15C15.9946 15 16.9484 14.6049 17.6517 13.9017C18.3549 13.1984 18.75 12.2446 18.75 11.25C18.75 10.2554 18.3549 9.30161 17.6517 8.59835C16.9484 7.89509 15.9946 7.5 15 7.5Z"
        fill="rgb(140, 140, 140)"
      />
    </svg>
  );
};
export const UserImgSvg = ({ onClick }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.00001 6.66683C9.47277 6.66683 10.6667 5.47292 10.6667 4.00016C10.6667 2.5274 9.47277 1.3335 8.00001 1.3335C6.52725 1.3335 5.33334 2.5274 5.33334 4.00016C5.33334 5.47292 6.52725 6.66683 8.00001 6.66683Z"
        fill="#667085"
        fillOpacity="0.63"
      />
      <path
        d="M13.3333 11.667C13.3333 13.3237 13.3333 14.667 8.00001 14.667C2.66667 14.667 2.66667 13.3237 2.66667 11.667C2.66667 10.0103 5.05467 8.66699 8.00001 8.66699C10.9453 8.66699 13.3333 10.0103 13.3333 11.667Z"
        fill="#667085"
        fillOpacity="0.63"
      />
    </svg>
  );
};
export const SearchSvg = ({ onClick }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M14.0177 14L11.1224 11.1047M11.1224 11.1047C11.6176 10.6094 12.0105 10.0215 12.2785 9.37438C12.5466 8.72729 12.6845 8.03375 12.6845 7.33335C12.6845 6.63295 12.5466 5.9394 12.2785 5.29232C12.0105 4.64523 11.6176 4.05727 11.1224 3.56202C10.6271 3.06676 10.0392 2.6739 9.39208 2.40586C8.74499 2.13783 8.05145 1.99988 7.35105 1.99988C6.65065 1.99988 5.9571 2.13783 5.31002 2.40586C4.66293 2.6739 4.07497 3.06676 3.57972 3.56202C2.5795 4.56224 2.01758 5.91882 2.01758 7.33335C2.01758 8.74787 2.5795 10.1045 3.57972 11.1047C4.57994 12.1049 5.93652 12.6668 7.35105 12.6668C8.76557 12.6668 10.1222 12.1049 11.1224 11.1047Z"
        stroke="#3182CE"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SearchBlackSvg = ({ onClick }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13 13L10.1047 10.1047M10.1047 10.1047C10.5999 9.60942 10.9928 9.02147 11.2608 8.37438C11.5288 7.72729 11.6668 7.03375 11.6668 6.33335C11.6668 5.63295 11.5289 4.9394 11.2608 4.29232C10.9928 3.64523 10.5999 3.05727 10.1047 2.56202C9.60941 2.06676 9.02145 1.6739 8.37436 1.40586C7.72728 1.13783 7.03373 0.999878 6.33333 0.999878C5.63293 0.999878 4.93939 1.13783 4.2923 1.40586C3.64522 1.6739 3.05726 2.06676 2.562 2.56202C1.56178 3.56224 0.999863 4.91882 0.999863 6.33335C0.999863 7.74787 1.56178 9.10446 2.562 10.1047C3.56222 11.1049 4.91881 11.6668 6.33333 11.6668C7.74786 11.6668 9.10445 11.1049 10.1047 10.1047Z"
        stroke="#ABB8C7"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SelectSvg = ({ onClick }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
    >
      <path
        d="M13 -5.99994L13 10.0001L-3 10.0001L-3 -5.99994L13 -5.99994Z"
        fill="#A0AEC0"
      />
    </svg>
  );
};
export const ToothSvg = ({ color, onClick }: any) => {
  return (
    <div className="toothsvgone">
      <svg
        viewBox="181.818 261.818 498.181 188.182"
        width="35"
        height="63"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
      >
        <path
          strokeWidth="10"
          fill={color}
          style={{ stroke: "rgb(0, 0, 0)" }}
          d="M 181.507 301.928 L 332.02 449.634 C 332.02 449.634 426.933 357.53 528.024 449.636 L 679.662 303.614 C 679.662 303.614 655.518 231.704 471.301 280.589 C 446.875 287.072 440.412 285.08 411.77 282.833 C 383.128 280.587 216.889 224.989 181.507 301.928 Z"
          transform="matrix(1, 0, 0, 1, -2.842170943040401e-14, 0)"
        />
      </svg>
    </div>
    
  );
};
export const BigToothSvg = ({ color, onClick }: any) => {
  return (
    <div className="toothsvgone">
      <svg
        viewBox="150 200 600 300" 
        width="200"   
        height="350" 
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
      >
        <path
          strokeWidth="10"
          fill={color}
          style={{ stroke: "rgb(0, 0, 0)" }}
          d="M 181.507 301.928 L 332.02 449.634 C 332.02 449.634 426.933 357.53 528.024 449.636 L 679.662 303.614 C 679.662 303.614 655.518 231.704 471.301 280.589 C 446.875 287.072 440.412 285.08 411.77 282.833 C 383.128 280.587 216.889 224.989 181.507 301.928 Z"
          transform="matrix(1, 0, 0, 1, -2.842170943040401e-14, 0)"
        />
      </svg>
    </div>
    
  );
};
export const DeleteSvg = ({ color, onClick }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M4.49967 12.6667C4.49967 13.4 5.09967 14 5.83301 14H11.1663C11.8997 14 12.4997 13.4 12.4997 12.6667V4.66667H4.49967V12.6667ZM13.1663 2.66667H10.833L10.1663 2H6.83301L6.16634 2.66667H3.83301V4H13.1663V2.66667Z"
        fill="white"
      />
    </svg>
  );
};
export const EditSvg = ({ color, onClick }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_120_1880)">
        <path
          d="M1.40407 7.73334L0.770732 10.4667C0.748884 10.5666 0.749633 10.6701 0.772924 10.7697C0.796215 10.8693 0.84146 10.9624 0.905353 11.0423C0.969246 11.1222 1.05017 11.1868 1.14222 11.2313C1.23427 11.2759 1.33512 11.2994 1.4374 11.3C1.48506 11.3048 1.53308 11.3048 1.58073 11.3L4.33073 10.6667L9.61073 5.40667L6.66406 2.46667L1.40407 7.73334Z"
          fill="white"
        />
        <path
          d="M11.2706 2.77336L9.30397 0.806697C9.17467 0.678052 8.9997 0.605835 8.8173 0.605835C8.63491 0.605835 8.45994 0.678052 8.33064 0.806697L7.2373 1.90003L10.1806 4.84336L11.274 3.75003C11.338 3.68572 11.3886 3.60943 11.4231 3.52552C11.4576 3.44161 11.4751 3.35172 11.4748 3.26101C11.4745 3.17029 11.4563 3.08053 11.4213 2.99685C11.3863 2.91318 11.3351 2.83723 11.2706 2.77336Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_120_1880">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(-0.00292969)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ArrowLeftSVG = ({ onClick }: any) => (
  <svg
    onClick={onClick}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7071 5.29289C13.0976 5.68342 13.0976 6.31658 12.7071 6.70711L9.41421 10L12.7071 13.2929C13.0976 13.6834 13.0976 14.3166 12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289L11.2929 5.29289C11.6834 4.90237 12.3166 4.90237 12.7071 5.29289Z"
      fill="#71717A"
    />
  </svg>
);
export const ArrowRightSVG = ({ onClick }: any) => (
  <svg
    onClick={onClick}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L10.5858 10L7.29289 6.70711C6.90237 6.31658 6.90237 5.68342 7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289L12.7071 9.29289C13.0976 9.68342 13.0976 10.3166 12.7071 10.7071L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071Z"
      fill="#71717A"
    />
  </svg>
);
export const CloseSVG = ({ onClick }: any) => (
  <svg
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M18.3218 6.5L6.32178 18.5M6.32178 6.5L18.3218 18.5"
      stroke="#667085"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const TimeSVG = ({ onClick }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_291_2244)">
      <path
        d="M8.00001 1.33301C11.682 1.33301 14.6667 4.31767 14.6667 7.99967C14.6667 11.6817 11.682 14.6663 8.00001 14.6663C4.31801 14.6663 1.33334 11.6817 1.33334 7.99967C1.33334 4.31767 4.31801 1.33301 8.00001 1.33301ZM8.00001 3.99967C7.8232 3.99967 7.65363 4.06991 7.52861 4.19494C7.40358 4.31996 7.33334 4.48953 7.33334 4.66634V7.99967C7.33338 8.17647 7.40364 8.34601 7.52868 8.47101L9.52868 10.471C9.65441 10.5924 9.82281 10.6596 9.99761 10.6581C10.1724 10.6566 10.3396 10.5865 10.4632 10.4629C10.5868 10.3393 10.6569 10.1721 10.6585 9.99728C10.66 9.82248 10.5928 9.65408 10.4713 9.52834L8.66668 7.72367V4.66634C8.66668 4.48953 8.59644 4.31996 8.47141 4.19494C8.34639 4.06991 8.17682 3.99967 8.00001 3.99967Z"
        fill="#A0AEC0"
      />
    </g>
    <defs>
      <clipPath id="clip0_291_2244">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
